
const area = {
  options: [{
    value: 'hubei',
    label: '湖北省',
    children: [{
      value: 'wuhanshi',
      label: '武汉市',
      children: [{
        value: 'hongshanqu',
        label: '洪山区',
        childrens: [{
          value: 'one', label: '洪山区第一医院'
        }, {
          value: 'two', label: '洪山区第二医院'
        }, {
          value: 'three', label: '洪山区第三医院'
        }]
      }, {
        value: 'jiangxiaqu',
        label: '江夏区',
        childrens: [{
          value: 'one', label: '江夏区区第一医院'
        }, {
          value: 'two', label: '江夏区第二医院'
        }, {
          value: 'three', label: '江夏区第三医院'
        }]
      }, {
        value: 'hankouqu',
        label: '江汉区',
        childrens: [{
          value: 'one', label: '江汉区第一医院'
        }, {
          value: 'two', label: '江汉区第二医院'
        }, {
          value: 'three', label: '江汉区第三医院'
        }]
      }, {
        value: 'qiaokouqu',
        label: '硚口区',
        childrens: [{
          value: 'one', label: '硚口区第一医院'
        }, {
          value: 'two', label: '硚口区第二医院'
        }, {
          value: 'three', label: '硚口区第三医院'
        }]
      }]
    }, {
      value: 'huanggangshi',
      label: '黄冈市',
      children: [{
        value: 'cexiangdaohang',
        label: '侧向导航'
      }, {
        value: 'dingbudaohang',
        label: '顶部导航'
      }]
    }]
  }, {
    value: 'guangxisheng',
    label: '广西省',
    children: [{
      value: 'liuzhoushi',
      label: '柳州市',
      children: [{
        value: 'layout',
        label: 'Layout 布局'
      }, {
        value: 'color',
        label: 'Color 色彩'
      }, {
        value: 'typography',
        label: 'Typography 字体'
      }, {
        value: 'icon',
        label: 'Icon 图标'
      }, {
        value: 'button',
        label: 'Button 按钮'
      }]
    }, {
      value: 'nanningshi',
      label: '南宁市',
      children: [{
        value: 'radio',
        label: 'Radio 单选框'
      }, {
        value: 'checkbox',
        label: 'Checkbox 多选框'
      }, {
        value: 'input',
        label: 'Input 输入框'
      }, {
        value: 'input-number',
        label: 'InputNumber 计数器'
      }, {
        value: 'select',
        label: 'Select 选择器'
      }, {
        value: 'cascader',
        label: 'Cascader 级联选择器'
      }, {
        value: 'switch',
        label: 'Switch 开关'
      }, {
        value: 'slider',
        label: 'Slider 滑块'
      }, {
        value: 'time-picker',
        label: 'TimePicker 时间选择器'
      }, {
        value: 'date-picker',
        label: 'DatePicker 日期选择器'
      }, {
        value: 'datetime-picker',
        label: 'DateTimePicker 日期时间选择器'
      }, {
        value: 'upload',
        label: 'Upload 上传'
      }, {
        value: 'rate',
        label: 'Rate 评分'
      }, {
        value: 'form',
        label: 'Form 表单'
      }]
    }, {
      value: 'guilinshi',
      label: '桂林市',
      children: [{
        value: 'table',
        label: 'Table 表格'
      }, {
        value: 'tag',
        label: 'Tag 标签'
      }, {
        value: 'progress',
        label: 'Progress 进度条'
      }, {
        value: 'tree',
        label: 'Tree 树形控件'
      }, {
        value: 'pagination',
        label: 'Pagination 分页'
      }, {
        value: 'badge',
        label: 'Badge 标记'
      }]
    }, {
      value: 'baiseshi',
      label: '百色市',
      children: [{
        value: 'alert',
        label: 'Alert 警告'
      }, {
        value: 'loading',
        label: 'Loading 加载'
      }, {
        value: 'message',
        label: 'Message 消息提示'
      }, {
        value: 'message-box',
        label: 'MessageBox 弹框'
      }, {
        value: 'notification',
        label: 'Notification 通知'
      }]
    }, {
      value: 'yulinshi',
      label: '玉林市',
      children: [{
        value: 'menu',
        label: 'NavMenu 导航菜单'
      }, {
        value: 'tabs',
        label: 'Tabs 标签页'
      }, {
        value: 'breadcrumb',
        label: 'Breadcrumb 面包屑'
      }, {
        value: 'dropdown',
        label: 'Dropdown 下拉菜单'
      }, {
        value: 'steps',
        label: 'Steps 步骤条'
      }]
    }, {
      value: 'others',
      label: 'Others',
      children: [{
        value: 'dialog',
        label: 'Dialog 对话框'
      }, {
        value: 'tooltip',
        label: 'Tooltip 文字提示'
      }, {
        value: 'popover',
        label: 'Popover 弹出框'
      }, {
        value: 'card',
        label: 'Card 卡片'
      }, {
        value: 'carousel',
        label: 'Carousel 走马灯'
      }, {
        value: 'collapse',
        label: 'Collapse 折叠面板'
      }]
    }]
  }, {
    value: 'taiwansheng',
    label: '台湾省',
    children: [{
      value: 'gaoxiongshi',
      label: '高雄市'
    }, {
      value: 'taibeishi',
      label: '台北市'
    }, {
      value: 'alishanshi',
      label: '阿里山市'
    }]
  }]
}
export default area;